import type { Staff, UpdateStaffRequest } from "../../types";
import type { EndpointBuilder } from "@reduxjs/toolkit/query/react";

export const staffMutations = (builder: EndpointBuilder<any, string, string>) => ({
  inviteStaff: builder.mutation<Staff, { email: string; role: string }>({
    query: (data: { email: string; role: string }) => ({
      url: "admin/staff/invite",
      method: "POST",
      body: data,
    }),
    invalidatesTags: [{ type: "Staff", id: "LIST" }],
  }),

  updateStaff: builder.mutation<Staff,{ id: string; data: UpdateStaffRequest }>({
    query: ({ id, data }: { id: string; data: UpdateStaffRequest }) => ({
      url: `admin/staff/${id}`,
      method: "PATCH",
      body: data,
    }),
    invalidatesTags: (_result: any, _error: any, { id }: { id: string }) => [
      { type: "Staff", id },
      { type: "Staff", id: "LIST" },
    ],
  }),

  deleteStaff: builder.mutation<void, string>({
    query: (id: string) => ({
      url: `admin/staff/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: (_result: any, _error: any, id: string) => [
      { type: "Staff", id },
      { type: "Staff", id: "LIST" },
    ],
  }),

  suspendStaff: builder.mutation<Staff, string>({
    query: (id: string) => ({
      url: `admin/staff/${id}/suspend`,
      method: "POST",
    }),
    invalidatesTags: (_result: any, _error: any, id: string) => [
      { type: "Staff", id },
      { type: "Staff", id: "LIST" },
    ],
  }),

  activateStaff: builder.mutation<Staff, string>({
    query: (id: string) => ({
      url: `admin/staff/${id}/activate`,
      method: "POST",
    }),
    invalidatesTags: (_result: any, _error: any, id: string) => [
      { type: "Staff", id },
      { type: "Staff", id: "LIST" },
    ],
  }),
});